export const subMenus = {
  store: [
    {
      Title: "쇼핑하기",
      items: [
        { menu: "최신 제품 쇼핑하기", link: "/store" },
        { menu: "Mac", link: "/" },
        { menu: "iPad", link: "/" },
        { menu: "iPhone", link: "/" },
        { menu: "Apple Watch", link: "/" },
        { menu: "액세서리", link: "/" },
      ],
    },
    {
      Title: "빠른 링크",
      items: [
        { menu: "매장 찾기", link: "/map" },
        { menu: "주문 상태", link: "/" },
        { menu: "Apple Trade In", link: "/" },
        { menu: "할부 방식", link: "/" },
      ],
    },
    {
      Title: "특별 할인 쇼핑하기",
      items: [
        { menu: "인증 리퍼비쉬 제품", link: "/" },
        { menu: "교육", link: "/" },
        { menu: "비즈니스", link: "/" },
      ],
    },
  ],
  mac: [
    {
      Title: "Mac 살펴보기",
      items: [
        { menu: "Mac 모두 살펴보기", link: "/" },
        { menu: "MacBook Air", link: "/" },
        { menu: "MacBook Pro", link: "/" },
        { menu: "iMac", link: "/" },
        { menu: "Mac mini", link: "/" },
        { menu: "Mac Studio", link: "/" },
      ],
    },
    {
      Title: "Mac 쇼핑하기",
      items: [
        { menu: "Mac 쇼핑하기", link: "/" },
        { menu: "Mac 액세서리", link: "/" },
        { menu: "Apple Trade In", link: "/" },
        { menu: "할부 방식", link: "/" },
      ],
    },
    {
      Title: "그 외 Mac 관련 항목",
      items: [
        { menu: "Mac 지원", link: "/" },
        { menu: "Mac을 위한 AppleCare+", link: "/" },
        { menu: "macOS Sequoia 미리보기", link: "/" },
        { menu: "Apple Intelligence", link: "/" },
        { menu: "Apple이 만든 앱", link: "/" },
        { menu: "연속성", link: "/" },
        { menu: "iCloud+", link: "/" },
        { menu: "Mac과 비즈니스", link: "/" },
        { menu: "교육", link: "/" },
      ],
    },
  ],
  ipad: [
    {
      Title: "iPad 살펴보기",
      items: [
        { menu: "iPad 모두 살펴보기", link: "/" },
        { menu: "iPad Pro", link: "/" },
        { menu: "iPad Air", link: "/" },
        { menu: "iPad", link: "/" },
        { menu: "iPad mini", link: "/" },
        { menu: "Apple Pencil", link: "/" },
        { menu: "키보드", link: "/" },
      ],
    },
    {
      Title: "iPad 쇼핑하기",
      items: [
        { menu: "iPad 쇼핑하기", link: "/" },
        { menu: "iPad 액세서리", link: "/" },
        { menu: "Apple Trade In", link: "/" },
        { menu: "할부 방식", link: "/" },
      ],
    },
    {
      Title: "그 외 iPad 관련 항목",
      items: [
        { menu: "iPad 지원", link: "/" },
        { menu: "iPad를 위한 AppleCare+", link: "/" },
        { menu: "iPadOS 18", link: "/" },
        { menu: "Apple Intelligence", link: "/" },
        { menu: "Apple이 만든 앱", link: "/" },
        { menu: "iCloud+", link: "/" },
        { menu: "교육", link: "/" },
      ],
    },
  ],
  iphone: [
    {
      Title: "iPhone 살펴보기",
      items: [
        { menu: "iPhone 모두 살펴보기", link: "/" },
        { menu: "iPhone 16 Pro", link: "/" },
        { menu: "iPhone 16", link: "/" },
        { menu: "iPhone 15", link: "/" },
        { menu: "iPhone 14", link: "/" },
        { menu: "iPhone SE", link: "/" },
      ],
    },
    {
      Title: "iPhone 쇼핑하기",
      items: [
        { menu: "iPhone 쇼핑하기", link: "/" },
        { menu: "iPhone 액세서리", link: "/" },
        { menu: "Apple Trade In", link: "/" },
        { menu: "할부 방식", link: "/" },
      ],
    },
    {
      Title: "그 외 iPhone 관련 항목",
      items: [
        { menu: "iPhone 지원", link: "/" },
        { menu: "iPhone 위한 AppleCare+", link: "/" },
        { menu: "iOS 18", link: "/" },
        { menu: "Apple Intelligence", link: "/" },
        { menu: "Apple이 만든 앱", link: "/" },
        { menu: "iPhone의 개인 정보 보호", link: "/" },
        { menu: "iCloud+", link: "/" },
        { menu: "Apple 지갑, Apple pay", link: "/" },
        { menu: "Siri", link: "/" },
      ],
    },
  ],
  watch: [
    {
      Title: "Watch 살펴보기",
      items: [
        { menu: "Apple Watch 모두 살펴보기", link: "/" },
        { menu: "Apple Watch Series 10", link: "/" },
        { menu: "Apple Watch Ultra 2", link: "/" },
        { menu: "Apple Watch SE", link: "/" },
        { menu: "Apple Watch Nike", link: "/" },
        { menu: "Apple Watch Hermès", link: "/" },
      ],
    },
    {
      Title: "Watch 쇼핑하기",
      items: [
        { menu: "Apple Watch 쇼핑하기", link: "/" },
        { menu: "Apple Watch Studio", link: "/" },
        { menu: "Apple Watch 밴드", link: "/" },
        { menu: "Apple Watch 액세서리", link: "/" },
        { menu: "Apple Trade In", link: "/" },
        { menu: "할부 방식", link: "/" },
      ],
    },
    {
      Title: "그 외 Watch 관련 항목",
      items: [
        { menu: "Apple Watch 지원", link: "/" },
        { menu: "AppleCare+", link: "/" },
        { menu: "WatchOS 11", link: "/" },
        { menu: "Apple이 만든 앱", link: "/" },
      ],
    },
  ],
  airpods: [
    {
      Title: "AirPods 살펴보기",
      items: [
        { menu: "AirPods 모두 살펴보기", link: "/" },
        { menu: "AirPods 4", link: "/" },
        { menu: "AirPods Pro 2", link: "/" },
        { menu: "AirPods Max", link: "/" },
      ],
    },
    {
      Title: "AirPods 쇼핑하기",
      items: [
        { menu: "AirPods 쇼핑하기", link: "/" },
        { menu: "AirPods 액세서리", link: "/" },
      ],
    },
    {
      Title: "그 외 AirPods 관련 항목",
      items: [
        { menu: "AirPods 지원", link: "/" },
        { menu: "헤더폰을 위한 AppleCare+", link: "/" },
        { menu: "Apple Music", link: "/" },
      ],
    },
  ],
  tvHome: [
    {
      Title: "TV 및 홈 살펴보기",
      items: [
        { menu: "TV 및 홈 살펴보기", link: "/" },
        { menu: "Apple TV 4k", link: "/" },
      ],
    },
    {
      Title: "TV 및 홈 쇼핑하기",
      items: [
        { menu: "Apple TV 4K 쇼핑하기", link: "/" },
        { menu: "Mac 액세서리", link: "/" },
        { menu: "Siri Remote 쇼핑하기", link: "/" },
        { menu: "TV 및 홈 액세서리", link: "/" },
      ],
    },
    {
      Title: "그 외 TV 및 홈 관련 항목",
      items: [
        { menu: "Apple TV 지원", link: "/" },
        { menu: "AppleCare+", link: "/" },
        { menu: "Apple TV 앱", link: "/" },
        { menu: "Apple TV+", link: "/" },
        { menu: "홈 앱", link: "/" },
        { menu: "Apple Music", link: "/" },
        { menu: "Siri", link: "/" },
        { menu: "AirPlay", link: "/" },
      ],
    },
  ],
  entertain: [
    {
      Title: "엔터테인먼트 살펴보기",
      items: [
        { menu: "엔터테인먼트 살펴보기", link: "/" },
        { menu: "Apple One", link: "/" },
        { menu: "Apple TV+", link: "/" },
        { menu: "Apple Music", link: "/" },
        { menu: "Apple Arcade", link: "/" },
        { menu: "Apple Podcasts", link: "/" },
        { menu: "Apple Books", link: "/" },
        { menu: "App Store", link: "/" },
      ],
    },
    {
      Title: "지원",
      items: [
        { menu: "Apple TV+ 지원", link: "/" },
        { menu: "Apple Music 지원", link: "/" },
      ],
    },
  ],
  accessories: [
    {
      Title: "액세서리 쇼핑하기",
      items: [
        { menu: "액세서리 모두 쇼핑하기", link: "/" },
        { menu: "Mac", link: "/" },
        { menu: "iPad", link: "/" },
        { menu: "iPhone", link: "/" },
        { menu: "Apple Watch", link: "/" },
        { menu: "AirPods", link: "/" },
        { menu: "TV 및 홈", link: "/" },
      ],
    },
    {
      Title: "액세서리 살펴보기",
      items: [
        { menu: "Apple 제작 정품", link: "/" },
        { menu: "Beats by Dr.Dre", link: "/" },
        { menu: "AirTag", link: "/" },
      ],
    },
  ],
  support: [
    {
      Title: "지원 상황 살펴보기",
      items: [
        { menu: "iPhone", link: "/" },
        { menu: "Mac", link: "/" },
        { menu: "iPad", link: "/" },
        { menu: "Watch", link: "/" },
        { menu: "AirPods", link: "/" },
        { menu: "Music", link: "/" },
        { menu: "TV", link: "/" },
      ],
    },
    {
      Title: "도움 받기",
      items: [
        { menu: "커뮤니티", link: "/" },
        { menu: "보장 상태 확인하기", link: "/" },
        { menu: "수리", link: "/" },
        { menu: "문의하기", link: "/" },
      ],
    },
    {
      Title: "유용한 주제",
      items: [
        { menu: "AppleCare+ 구입하기", link: "/" },
        { menu: "Apple ID 및 암호", link: "/" },
        { menu: "청구 및 구독", link: "/" },
        { menu: "나의 찾기", link: "/" },
        { menu: "손쉬운 사용", link: "/" },
      ],
    },
  ],
};
